import angular from 'angular'
import { DashboardModule } from '../../dashboard/dashboard.module';

import { PayrollDashboardComponent } from './payroll-dashboard.component';
import { DashboardPendingPayrollsContainerComponent } from './pending-payrolls-container.component';
import { DashboardPendingPayrollsComponent } from './pending-payrolls.component';
import { DashboardSubmittedPayrollContainerComponent } from './submitted-payrolls-container.component';
import { DashboardSubmittedPayrollsComponent } from './submitted-payrolls.component';

import { dashboardPendingPayrollsItemTemplate, dashboardPendingPayrollsListItemTemplate } from './dashboard-pending-payrolls-templates.block';
import { dashboardSubmittedPayrollsItemTemplate, dashboardSubmittedPayrollsListItemTemplate } from './dashboard-submitted-payrolls-templates.block';

/** A module that includes dashboard components and widgets containing payroll data. */
export const PayrollDashboardModule = angular
    .module('apex.mainApp.payroll.dashboard', [
        // Use common dashboard components and services to build the specialized dashboards.
        DashboardModule
    ])
    .component("apexPayrollDashboard", PayrollDashboardComponent)
    .component("apexDashboardPendingPayrollsContainer", DashboardPendingPayrollsContainerComponent)
    .component("apexDashboardPendingPayrolls", DashboardPendingPayrollsComponent)
    .component("apexDashboardSubmittedPayrollsContainer", DashboardSubmittedPayrollContainerComponent)
    .component("apexDashboardSubmittedPayrolls", DashboardSubmittedPayrollsComponent)
    .run(dashboardPendingPayrollsItemTemplate)
    .run(dashboardPendingPayrollsListItemTemplate)
    .run(dashboardSubmittedPayrollsItemTemplate)
    .run(dashboardSubmittedPayrollsListItemTemplate)
    .name;
